import styled from '@emotion/styled';

interface SectionGridProps {
  /** Columnas en escritorio. Por omisión 3, que es como nació la rejilla. */
  columns?: number;
}

/**
 * Organismo de layout: rejilla responsiva que coloca las `SectionCard`.
 * `columns` columnas en escritorio, dos en pantallas medianas y una en móvil.
 */
const SectionGrid = styled.div<SectionGridProps>(({ columns = 3 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  gap: 22,
  maxWidth: 1120,
  '@media (max-width: 1100px)': { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
  '@media (max-width: 720px)': { gridTemplateColumns: '1fr' },
}));

export default SectionGrid;
